module.exports = "<ion-content padding=\"true\">\n  <list-received-product></list-received-product>\n</ion-content>\n"